import script from "./PhoneNumber.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneNumber.vue?vue&type=script&setup=true&lang=js"

import "./PhoneNumber.vue?vue&type=style&index=0&id=565910d7&lang=css"

const __exports__ = script;

export default __exports__